import { render } from "./cardBill.vue?vue&type=template&id=335c3820"
import script from "./cardBill.vue?vue&type=script&lang=js"
export * from "./cardBill.vue?vue&type=script&lang=js"

import "./cardBill.vue?vue&type=style&index=0&id=335c3820&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__